<template>
  <sources :active="active"/>
</template>

<script>
  /*source component from tabs directory of analytics*/

  // components
  import Sources from '@/components/source/Sources.vue';

  export default {
    name: "Source",
    props: {
      active: {
        type: Boolean
      }
    },
    components: {
      Sources,
    }
  };
</script>

